/**
 * @generated SignedSource<<590483254f3e5ae0689c5da4f6f780a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription$data = {
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription">;
  readonly " $fragmentType": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription";
};
export type ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription$key = {
  readonly " $data"?: ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_softwareReleasesVersionSummaryDescription_VersionSummaryDescription",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "ed1e590e92f538e88d28c5f6bba7c77c";

export default node;
